export default {
    terms: [
        'You must be at least 18 years old to register.',
        'You agree to provide true and correct information about yourself in the registration process',
        'You agree not to use sharekomry.com for harassing, threatening, abusing, religious or racially offensive material.',
        'You agree not to use sharekomry.com for the transmission of "spam", "chain letters" or for any commercial purposes.'
    ]

    // term1:'You must be at least 18 years old to register.',
    // term2:'You agree to provide true and correct information about yourself in the registration process',
    // term3:'You agree not to use sharekomry.com for harassing, threatening, abusing, religious or racially offensive material.',
    // term4:'You agree not to use sharekomry.com for the transmission of "spam", "chain letters" or for any commercial purposes.',
}
